import { render } from "./TagColorPicker.vue?vue&type=template&id=f6a8268a&scoped=true"
import script from "./TagColorPicker.vue?vue&type=script&lang=js"
export * from "./TagColorPicker.vue?vue&type=script&lang=js"

import "./TagColorPicker.vue?vue&type=style&index=0&id=f6a8268a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a8268a"]])

export default __exports__